{
  "name": "ngx-aur-mat-table",
  "version": "19.18.1",
  "repository": {
    "type": "git",
    "url": "https://github.com/NikolayNN/ngx-aur-mat-table.git"
  },
  "peerDependencies": {
    "@angular/animations": "^19.2.17",
    "@angular/common": "^19.2.17",
    "@angular/compiler": "^19.2.17",
    "@angular/core": "^19.2.17",
    "@angular/forms": "^19.2.17",
    "@angular/platform-browser": "^19.2.17",
    "@angular/platform-browser-dynamic": "^19.2.17",
    "@angular/router": "^19.2.17",
    "@angular/material": "^19.2.17"
  },
  "dependencies": {
    "tslib": "^2.3.0"
  }
}
